import React from 'react'
import { Navbar } from "flowbite-react";
import { useAuth } from '../hooks/AuthContext';
import { useNavigate } from 'react-router-dom';

const LogoutLink = () => {

    const { logout } = useAuth();

    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/');
    };

  return (
    <Navbar.Link href="#" onClick={handleLogout}>Cerrar</Navbar.Link>
  )
}

export default LogoutLink
